<div class="header-container">
  <div class="header-wrap">
    <div class="header">
      <div class="text">Top Decisions</div>
      <div class="img"><img src="/assets/img/game/leaderboard-icon.svg"></div>
    </div>
    <div class="table-header">
      <div class="col-1-2-3">
        <div class="col-1-2">
          <div class="col-1">Team</div>
          <div class="col-2">Score</div>
        </div>
        <div class="col-3">Most Effective Resource Allocations</div>
      </div>
    </div>
  </div>
</div>
<div class="table-container">
  <div class="table-wrap">
    <div *ngIf="!data" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <ion-skeleton-text
        *ngFor="let i of [1, 2]" [animated]="true"
        style="width: 100%; height: 5rem; border-radius: 1rem;"
      ></ion-skeleton-text>
    </div>
    <div class="rows" *ngIf="data">
      <div class="row" *ngFor="let team of data; let i = index">
        <div class="col-1">{{ team.first_name }} {{ team.last_name }}</div>
        <div class="col-2">{{ team.score }}</div>
        <div class="col-3">
          <ng-container *ngFor="let allocation of team.summary?.mostEffective; let j = index">
            <div *ngIf="j < 2" class="allocation">
              <div *ngIf="allocation.type === 'time'" class="allocation-color purple">
                <div class="allocation-name">Time</div>
                <div class="allocation-subname">(hrs per week)</div>
              </div>
              <div *ngIf="allocation.type === 'mcc'" class="allocation-color blue">
                <div class="allocation-name">MCC</div>
              </div>
              <div *ngIf="allocation.type === 'incentives'" class="allocation-color red">
                <div class="allocation-name">Incentives</div>
              </div>
              <div *ngIf="allocation.type === 'tposm'" class="allocation-color green">
                <div class="allocation-name">TPOSM</div>
              </div>
              <div class="text">{{ allocation.title }}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="footer">
      <img class="taerra-logo" src="/assets/img/game/taerra.svg">
      <div class="right-side">
        <img class="alchemist-logo" src="/assets/icon/alchemist-logo.svg">
        <img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
      </div>
    </div>
  </div>
</div>